import { createStyles } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    root: {
      height: 'calc(100vh - 144px)',
      overflowY: 'auto',
    },
    root1: {
      height: 'calc(100vh - 194px)',
      overflowY: 'auto',
    },
    card: {
      padding: '16px',
      overflowY: 'hidden',
      borderRadius: 0,
      '& .auditLogs': {
        fontSize: '14px',
        letterSpacing: '1.25px',
        fontWeight: 700,
      },
      '& .title': {
        fontSize: 28,
        fontWeight: 300,
      },
    },
    dividerGrid: {
      marginLeft: 16,
      marginRight: 16,
      alignSelf: 'center',
      height: 32,
    },
    flexColumn: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      justifyContent: 'center',
    },
    progressMargin: {
      marginLeft: '48%',
    },
    inspectioFileGrid: {
      marginTop: 16,
      marginBottom: 1,
      borderRadius: '10px 10px 0px 0px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    auditlogIcon: {
      marginLeft: 10,
      width: '28px !important',
      height: '28px !important',
    },
    divider: {
      backgroundColor: 'rgba(255, 255, 255, 0.4)',
    },
    reportText: {
      fontSize: 14,
      letterSpacing: '1.25px',
      fontWeight: 700,
      cursor: 'pointer',
    },
    downlaod: {
      marginLeft: 10,
      cursor: 'pointer',
    },
    subtitleGrid: {
      marginTop: 16,
      marginBottom: 1,
      borderRadius: '10px 10px 0px 0px',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
    },
    subtitleGridText: {
      padding: '8.5px 0px 7.5px 4px',
      fontStyle: 'normal',
    },
    deficiency: {
      padding: '8.5px 0px 7.5px 4px',
      fontStyle: 'normal',
    },
  }),
);

export default useStyles;
